import {name, Panes, Select} from '@management-ui/core';
import React, {useContext, useEffect, useRef, useState} from 'react';
import {ServiceContext} from '../../../../components/Services';

const Fields = ({entity = {}, prefix = ''}) => {
  const services = useContext(ServiceContext);
  const [users, setUsers] = useState([]);
  const optionsLoaded = useRef(false);

  useEffect(() => {
    if (!optionsLoaded.current) {
      optionsLoaded.current = true;
      services.user.getUsers({}, 1, 500).then((list) => {
        setUsers(list.data.map((user) => ({title: name(user), value: user.id})));
      }).catch(() => null);
    }
  }, [services]);

  return (
    <Panes
      entity={entity}
      prefix={prefix}
      panes={[
        {
          title: '',
          fields: [
            <Select
              name="user_id"
              prefix={prefix}
              label="User"
              options={users}
            />,
          ]
        }
      ]}
    />
  );
};

export default Fields;
